/**
 * View Context Hook
 *
 * Auto-detects whether the current route is a portal or admin view
 * based on the URL pathname. Used by unified hooks to route requests
 * to the correct API prefix (/api/* vs /portal/*).
 */

import { useLocation } from 'react-router-dom';

export type ViewScope = 'admin' | 'portal';

export function useViewContext() {
  const location = useLocation();
  const isPortalView = location.pathname.startsWith('/portal');
  const scope: ViewScope = isPortalView ? 'portal' : 'admin';
  const apiPrefix = isPortalView ? '/portal' : '/api';

  return { isPortalView, scope, apiPrefix } as const;
}
